<div class="otp-container">
  @for (digit of otpArray; track digit; let i = $index) {
    <input
      type="text"
      placeholder="-"
      maxlength="1"
      class="zp:placeholder:text-ZTN-900"
      [class]="inputClass"
      [(ngModel)]="otp[i]"
      (input)="onOtpInput($event, i)"
      (keydown.backspace)="onOtpBackspace($event, i)"
      (paste)="onOtpPaste($event)"
      />
  }
</div>
